import { useSelectedStudentIdContext } from "../exam-results/context/studentsList/context";
import Answer from "../exam-results/descriptivePage/Answer";
import styles from "./dq.module.scss";
import type { DqGlobalProps } from "./types";
import { useGetQuestions } from "./utils";

export const CorrectAnswerDescription = (props: DqGlobalProps) => {
  const { id } = props;
  const { selectedStudentId } = useSelectedStudentIdContext();
  const item = useGetQuestions(selectedStudentId, id)[0];

  return (
    <div className={styles["dq-answer-container"]}>
      <Answer {...item} />
    </div>
  );
};
